module.exports = __webpack_public_path__ + "static/media/OM.42aeefe5.svg";